import React from "react";
import ReportNavigation from "./ReportNavigation";
import { ReportLandingpage } from "./ReportLandingPage";
import Report from "./Report";
import cropr, { availableReportsType } from "../shared/utils/cropr";

interface Props {
  group: string;
  reportType: string;
}
const Reports = ({ group, reportType }: Props) => {
  const availableReports: availableReportsType = React.useMemo(
    () => cropr.getAvailableReports(),
    []
  );
  return (
    <>
      <ReportNavigation availableReports={availableReports} />
      <div style={{ marginLeft: "240px" }}>
        {(group && reportType && (
          <Report reportType={reportType} report={availableReports[group]["reports"][reportType]} />
        )) || <ReportLandingpage availableReports={availableReports} />}
      </div>
    </>
  );
};
export default Reports;
